/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _SuspendedInfoContainer_viewer$ref: unique symbol;
export type SuspendedInfoContainer_viewer$ref = typeof _SuspendedInfoContainer_viewer$ref;
export type SuspendedInfoContainer_viewer = {
    readonly status: {
        readonly suspension: {
            readonly until: string | null;
        };
    };
    readonly " $refType": SuspendedInfoContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SuspendedInfoContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "status",
            "storageKey": null,
            "args": null,
            "concreteType": "UserStatus",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "suspension",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SuspensionStatus",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "until",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'd1330697084b0a323c0c2dea0c5b2128';
export default node;
